import { render } from "./bracket-roundRobin-match.vue?vue&type=template&id=7a4cbf6a"
import script from "./bracket-roundRobin-match.vue?vue&type=script&lang=js"
export * from "./bracket-roundRobin-match.vue?vue&type=script&lang=js"

import "./bracket-roundRobin-match.vue?vue&type=style&index=0&id=7a4cbf6a&lang=scss"

import exportComponent from "/usr/src/app/frontend_result/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__